import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowLeft } from "lucide-react";
import MessagingSettings from "../components/MessagingSettings";

export default function MessagingSettingsPage() {
  return (
    <div className="space-y-6" data-testid="messaging-settings-page">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="sm" asChild>
            <Link to="/einstellungen">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Zurück
            </Link>
          </Button>
          <h1 className="text-2xl font-bold">SMS & WhatsApp Einstellungen</h1>
        </div>
      </div>

      {/* Messaging Settings Component */}
      <MessagingSettings />
    </div>
  );
}
